import { EstateFormTemplateKey } from '@/modules/estateformtemplate/constants/EstateFormTemplateKey';

export enum ExportTemplateType {
  DIRECTIONS_AND_AUTHORIZATION = 'directions_and_authorization',

  ESTATE_PLAN_MEMO = 'estate_plan_memo',

  GENERIC_FINANCIAL_INSTITUTION_LETTER = 'generic_financial_institution_letter',

  INTERIM_DISTRIBUTION_RELEASE = 'interim_distribution_release',

  LETTER_TO_DEPARTMENT_OF_HEALTH_CARE_SERVICES = 'letter_to_department_of_health_care_services',

  LETTER_TO_EQUIFAX = 'letter_to_equifax',

  LETTER_TO_EXPERIAN = 'letter_to_experian',

  LETTER_TO_FRANCHISE_TAX_BOARD = 'letter_to_franchise_tax_board',

  LETTER_TO_TRANSUNION = 'letter_to_transunion',

  LETTER_TO_VICTIMS_COMPENSATION_BOARD = 'letter_to_victims_compensation_board',

  LETTER_TO_FINANCIAL_INSTITUTION_BANK_ACCOUNT = 'letter_to_financial_institution_bank_account',

  LETTER_TO_FINANCIAL_INSTITUTION_LIFE_INSURANCE = 'letter_to_financial_institution_life_insurance',

  LETTER_TO_FINANCIAL_INSTITUTION_PENSION_PLAN = 'letter_to_financial_institution_pension_plan',

  LETTER_OF_FINAL_WISHES = 'letter_of_final_wishes',

  OWING_VOUCHER = 'owing_voucher',

  POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE = 'power_of_attorney_healthcare_directive',

  POWER_OF_ATTORNEY_PERSONAL_CARE = 'power_of_attorney_personal_care',

  POWER_OF_ATTORNEY_PROPERTY = 'power_of_attorney_property',

  POWER_OF_ATTORNEY_PROPERTY_AND_PERSONAL_CARE = 'power_of_attorney_property_and_personal_care',

  PROBATE_BRITISH_COLUMBIA_P1 = 'probate_british_columbia_p1',

  PROBATE_BRITISH_COLUMBIA_P10 = 'probate_british_columbia_p10',

  PROBATE_BRITISH_COLUMBIA_P2 = 'probate_british_columbia_p2',

  PROBATE_BRITISH_COLUMBIA_P3 = 'probate_british_columbia_p3',

  PROBATE_BRITISH_COLUMBIA_P5 = 'probate_british_columbia_p5',

  PROBATE_BRITISH_COLUMBIA_P8 = 'probate_british_columbia_p8',

  PROBATE_BRITISH_COLUMBIA_P9 = 'probate_british_columbia_p9',

  PROBATE_MANITOBA_AFFIDAVIT_EXECUTION_NOMINATION = 'probate_manitoba_affidavit_execution_nomination',

  PROBATE_MANITOBA_FORM_74A = 'probate_manitoba_form_74a',

  PROBATE_MANITOBA_FORM_74B = 'probate_manitoba_form_74b',

  PROBATE_MANITOBA_FORM_74C = 'probate_manitoba_form_74c',

  PROBATE_MANITOBA_FORM_74D = 'probate_manitoba_form_74d',

  PROBATE_MANITOBA_FORM_74E = 'probate_manitoba_form_74e',

  PROBATE_MANITOBA_FORM_74F = 'probate_manitoba_form_74f',

  PROBATE_MANITOBA_FORM_74J = 'probate_manitoba_form_74j',

  PROBATE_MANITOBA_FORM_74K = 'probate_manitoba_form_74k',

  PROBATE_MANITOBA_FORM_74L = 'probate_manitoba_form_74l',

  PROBATE_MANITOBA_FORM_74M = 'probate_manitoba_form_74m',

  PROBATE_MANITOBA_FORM_74N = 'probate_manitoba_form_74n',

  PROBATE_MANITOBA_FORM_74O = 'probate_manitoba_form_74o',

  PROBATE_MANITOBA_FORM_74R = 'probate_manitoba_form_74r',

  PROBATE_MANITOBA_FORM_74T1 = 'probate_manitoba_form_74t1',

  PROBATE_ONTARIO_FORM_74A = 'probate_ontario_form_74a',

  PROBATE_ONTARIO_FORM_74B = 'probate_ontario_form_74b',

  PROBATE_ONTARIO_FORM_74C = 'probate_ontario_form_74c',

  PROBATE_ONTARIO_FORM_74I = 'probate_ontario_form_74i',

  PROBATE_ONTARIO_AFFIDAVIT_DISPEND_BOND = 'probate_ontario_affidavit_dispense_bond',

  PROBATE_SASKATCHEWAN_FORM_11A = 'probate_saskatchewan_form_11a',

  PROBATE_SASKATCHEWAN_FORM_11B = 'probate_saskatchewan_form_11b',

  PROBATE_SASKATCHEWAN_FORM_11C = 'probate_saskatchewan_form_11c',

  PROBATE_SASKATCHEWAN_FORM_12 = 'probate_saskatchewan_form_12',

  PROBATE_SASKATCHEWAN_FORM_13A = 'probate_saskatchewan_form_13a',

  PROBATE_SASKATCHEWAN_FORM_13B = 'probate_saskatchewan_form_13b',

  PROBATE_SASKATCHEWAN_FORM_14 = 'probate_saskatchewan_form_14',

  PROBATE_SASKATCHEWAN_FORM_19A = 'probate_saskatchewan_form_19a',

  PROBATE_SASKATCHEWAN_FORM_19B = 'probate_saskatchewan_form_19b',

  PROBATE_SASKATCHEWAN_FORM_7 = 'probate_saskatchewan_form_7',

  PROTECTION_MANDATE = 'protection_mandate',

  QUEBEC_CLOSURE_OF_INVENTORY_RDPRM = 'quebec_closure_of_inventory_rdprm',

  QUEBEC_DESIGNATION_OF_LIQUIDATOR_RDPRM = 'quebec_designation_of_liquidator_rdprm',

  QUEBEC_DESIGNATION_OF_LIQUIDATOR_RDPRM_ANNEX = 'quebec_designation_of_liquidator_rdprm_annex',

  QUEBEC_INFORMATION_ABOUT_REPRESENTATIVE = 'quebec_information_about_representative',

  QUEBEC_INFORMATION_ABOUT_REPRESENTATIVE_INSTRUCTIONS = 'quebec_information_about_representative_instructions',

  QUEBEC_DESIGNATION_OF_LIQUIDATOR_BY_HEIRS = 'quebec_designation_of_liquidator_by_heirs',

  QUEBEC_DESIGNATION_OF_LIQUIDATOR_BY_HEIRS_INSTRUCTIONS = 'quebec_designation_of_liquidator_by_heirs_instructions',

  QUEBEC_DESIGNATION_OF_LIQUIDATOR_RDPRM_INSTRUCTIONS = 'quebec_designation_of_liquidator_rdprm_instructions',

  QUEBEC_CLOSURE_OF_INVENTORY_RDPRM_INSTRUCTIONS = 'quebec_closure_of_inventory_rdprm_instructions',

  WILL = 'will',

  WILL_COVER_PAGE = 'will_cover_page',

  WILL_COVER_SHEET = 'will_cover_sheet',

  WILLS_NOTICE_SEARCH = 'wills_notice_search',

  WILL_WITH_WITNESSES = 'will_with_witnesses',

  SECONDARY_WILL = 'secondary_will'
}

export function getExportTypeByEstateFormKey(
  key: EstateFormTemplateKey
): ExportTemplateType | null {
  switch (key) {
    case EstateFormTemplateKey.FORM_523201:
      return ExportTemplateType.PROBATE_ONTARIO_FORM_74A;
    case EstateFormTemplateKey.FORM_833724:
      return ExportTemplateType.PROBATE_ONTARIO_FORM_74B;
    case EstateFormTemplateKey.FORM_992177:
      return ExportTemplateType.PROBATE_ONTARIO_FORM_74C;
    case EstateFormTemplateKey.FORM_381570:
      return ExportTemplateType.PROBATE_ONTARIO_FORM_74I;
    case EstateFormTemplateKey.FORM_141210:
      return ExportTemplateType.PROBATE_ONTARIO_AFFIDAVIT_DISPEND_BOND;
    case EstateFormTemplateKey.FORM_478088:
      return ExportTemplateType.LETTER_TO_DEPARTMENT_OF_HEALTH_CARE_SERVICES;
    case EstateFormTemplateKey.FORM_120395:
      return ExportTemplateType.LETTER_TO_VICTIMS_COMPENSATION_BOARD;
    case EstateFormTemplateKey.FORM_967195:
      return ExportTemplateType.LETTER_TO_FRANCHISE_TAX_BOARD;
    default:
      return null;
  }
}
